const sodium = require('libsodium-wrappers');
// TODO: La clave debe ser gestionada de forma segura y no aparecer en el código fuente.
// Se puede usar en .env o un servicio de gestión de secretos.
const SECRET_KEY = 'RXJyb3IgZW4gbGEgY29uZXhpb24gZGlu';

export const EncryptService = {

    async encrypt(decryptData) {
        // Espera a que la inicialización de sodium se complete
        await sodium.ready;

        if (SECRET_KEY.length !== sodium.crypto_secretbox_KEYBYTES) {
            throw new Error('Longitud de clave incorrecta');
        }

        // Generar un nonce aleatorio
        const nonce = sodium.randombytes_buf(sodium.crypto_secretbox_NONCEBYTES);

        // Cifrar los datos
        const encryptedData = sodium.crypto_secretbox_easy(decryptData, nonce, SECRET_KEY);

        // Combinar el nonce y los datos cifrados
        const combinedData = new Uint8Array([...nonce, ...encryptedData]);

        // Reemplazar el carácter "/" en la codificación base64
        const encodedData = btoa(String.fromCharCode.apply(null, combinedData))
            .replace(/\//g, '_');

        // Devolver los datos cifrados
        return encodedData;

    },
    async decrypt(encryptedData) {
        try {
            // Espera a que la inicialización de sodium se complete
            await sodium.ready;

            // Decodificar la cadena base64url
            const combinedData = new Uint8Array(
                atob(encryptedData.replace(/-/g, '+').replace(/_/g, '/'))
                .split('')
                .map(c => c.charCodeAt(0))
            );

            // Extraer el nonce y los datos cifrados
            const nonce = combinedData.slice(0, sodium.crypto_secretbox_NONCEBYTES);
            const encryptedDataOnly = combinedData.slice(sodium.crypto_secretbox_NONCEBYTES);

            if (SECRET_KEY.length !== sodium.crypto_secretbox_KEYBYTES) {
                throw new Error('Longitud de clave incorrecta');
            }

            // Desencriptar los datos
            const decryptedData = sodium.crypto_secretbox_open_easy(
                encryptedDataOnly,
                nonce,
                SECRET_KEY
            );
            
            // Devolver los datos desencriptados como cadena
            return decryptedData ? String.fromCharCode.apply(null, decryptedData) : null;
        } catch (error) {
            return null
        }
        
    }
}

